var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "#009444",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#fff",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 0c-6.9031 0-12.5 5.5969-12.5 12.5 0 6.9031 5.5969 12.5 12.5 12.5s12.5-5.5969 12.5-12.5c0-6.9031-5.5969-12.5-12.5-12.5zm6.9865 10.111-7.875 7.875c-0.19583 0.19583-0.46042 0.30521-0.73646 0.30521-0.27604 0-0.54167-0.10938-0.73646-0.30521l-3.5969-3.5969c-0.40729-0.40729-0.40729-1.0656 0-1.4729 0.40729-0.40729 1.0656-0.40729 1.4729 0l2.8604 2.8604 7.1385-7.1385c0.40729-0.40729 1.0656-0.40729 1.4729 0 0.40729 0.40729 0.40729 1.0656 0 1.4729z",
    strokeWidth: 1.0417
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.e9fd4fc2952d2029970fb65abb81345b.svg";
export { ForwardRef as ReactComponent };